/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

const NotificationActions = {
  Show: 'Notification@SHOW',
  Hide: 'Notification@HIDE',
  ClearAll: 'Notification@CLEAR_ALL'
};

export default NotificationActions;